<template>
  <div>
    <div>
      <!------------------
            HEADER
    -------------------->
      <div class="bg-white pl-4 pr-4 pt-3 pb-3 page-header" ref="pageHeader">
        <div class="row align-items-center" style="max-width: 1000px">
          <div class="col">
            <div>
              <h4 @click="activeTab = 2">
                <!-- <b-icon icon="pencil" variant="secondary" class="mr-1"></b-icon> -->
                {{ record.DbId ? currentOrdinal + ' ' + currentDisplayName : 'Projektänderungstestat erfassen' }}
              </h4>
            </div>
          </div>
          <div class="col-auto">
            <div class="form-inline">
              <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
              <!-- <b-button variant="outline-secondary" class="" @click="saveRecordAndReturn">
              <b-icon icon="check2" variant="secondary" class="mr-1" style="padding-top:1px"></b-icon>
              Speichern
            </b-button> -->
              <b-button
                variant="secondary"
                class="text-white"
                @click="saveRecordAndReturn"
                v-if="!record.DbId && activeTab == 0"
              >
                <b-icon icon="check2" variant="white" class="mr-1" style="padding-top: 1px"></b-icon>
                Neue PÄT speichern
              </b-button>
              <b-button
                variant="secondary"
                class="text-white"
                @click="saveRecordAndReturn"
                v-if="record.DbId && activeTab == 0 && ($root.$user.isPlaner || $root.$user.isAdmin)"
                :disabled="!recordFormChanged"
              >
                <b-icon icon="check2" variant="white" class="mr-1" style="padding-top: 1px"></b-icon>
                PÄT speichern
              </b-button>
              <b-button
                :disabled="!allocationsChanged"
                variant="secondary"
                class="text-white"
                @click="saveAllocations"
                v-if="activeTab == 2 && ($root.$user.isPlaner || $root.$user.isAdmin)"
              >
                <b-icon icon="check2" variant="white" class="mr-1" style="padding-top: 1px"></b-icon>
                Zuordnungen speichern
              </b-button>
              <b-button
                @click="printIt"
                variant="light"
                class="ml-2"
                style="padding-top:3px;padding-bottom:2px;padding-left:9px;padding-right:9px;"
              >
                <b-icon icon="printer" style="" />
              </b-button>
              <b-button
                class="ml-2"
                variant="light"
                style="padding-top:3px;padding-bottom:2px;padding-left:9px;padding-right:9px;"
                @click="
                  recordFormChanged = false;
                  decisionFormChanged = false;
                  allocationsChanged = false;
                  $router.go(-1);
                "
              >
                <div>
                  <b-icon icon="x" variant="dark" style="padding-top: 1px; height:26px; width:26px;"></b-icon>
                </div>
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <div class="">
        <b-tabs
          @activate-tab="onTabChange"
          v-model="activeTab"
          content-class="px-0 py-0 bg-white "
          class="mt-3 form-tabs border-bottom"
        >
          <b-tab
            title="Grundinformationen"
            active
            class="p-4"
            :style="{ height: tabHeight, overflowY: 'auto', overflowX: 'hidden', position: 'relative' }"
          >
            <b-overlay :show="isLoading" rounded="sm" spinner-variant="primary" opacity="0.6">
              <b-form ref="recordForm" id="patRecordForm">
                <div class="row">
                  <div class="col pr-0" style="max-width: 465px">
                    <label class="text-muted d-block mb-1"><small>PÄT Nummer</small></label>
                    <b-input
                      v-model="record.Ordinal"
                      ref="patNumberField"
                      @keyup="onFormFieldKeyUp"
                      required
                      :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                      :disabled="!$root.$user.isPlaner && !$root.$user.isAdmin"
                      maxlength="50"
                    />
                    <label class="text-muted d-block mt-1 mb-1"><small>Datum</small></label>
                    <b-input
                      v-model="record.DateFormatted"
                      type="date"
                      min="2000-01-01"
                      max="2099-12-31"
                      required
                      :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                      @keyup="onFormFieldKeyUp"
                    />
                    <label class="text-muted d-block mt-1 mb-1"><small>Bezeichnung</small></label>
                    <b-input
                      required
                      v-model="record.DisplayName"
                      @keyup="onFormFieldKeyUp"
                      :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                      maxlength="100"
                    />
                  </div>
                  <div class="col" style="max-width: 535px">
                    <label class="text-muted d-block mb-1"><small>Beschreibung</small></label>
                    <b-form-textarea
                      id="textarea"
                      placeholder="Langtext..."
                      rows="7"
                      max-rows="7"
                      v-model="record.Description"
                      @keyup="onFormFieldKeyUp"
                      :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                    ></b-form-textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col" style="max-width: 1000px">
                    <h5 class="mt-3">Kalkulation</h5>
                    <hr class="mt-0" />
                  </div>
                </div>
                <div class="row">
                  <div class="col align-self-end" style="max-width: 700px">
                    <div class="row mt-2" v-for="(value, index) in record.BudgetParts" :key="index">
                      <div class="col col-1 pr-0 align-self-center">
                        <small>Pos {{ index + 1 }}</small>
                      </div>
                      <div class="col col-7 pr-0 pl-0">
                        <b-input
                          :placeholder="value.default"
                          v-model="value.description"
                          @keyup.enter="takeOverDescription(index)"
                          @keyup="onFormFieldKeyUp"
                          :required="value.value > 0"
                          :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                        />
                      </div>
                      <div class="col col-4">
                        <!--
                        <b-input-group append="€">
                          <AkCurrencyField
                            class="text-right"
                            v-model="record.BudgetParts[index].value"
                            placeholder="Betrag"
                            @keyup="onFormFieldKeyUp($event)"
                            @change="recalcBudgetSum()"
                            type="number"
                            step="0.01"
                            :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                          />
                        </b-input-group>
                        -->

                        <AkCurrencyField
                          input-class="text-right"
                          v-model="value.value"
                          placeholder="Betrag"
                          @keyup="onFormFieldKeyUp($event)"
                          @update="recalcBudgetSum()"
                          :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col align-self-end" style="max-width: 300px">
                    <label class="text-muted d-block mb-1"><small>Budgetbedarf PÄT:</small></label>
                    <!--
                    <b-input-group append="€">
                      <b-input
                        class="text-right bg-white no-outline no-focus"
                        placeholder="Betrag"
                        readonly
                        v-model="posTotalAmount"
                      />
                    </b-input-group>-->
                    <AkCurrencyField
                      input-class="text-right bg-white no-outline no-focus"
                      v-model="posTotalAmount"
                      readonly
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col" style="max-width: 1000px">
                    <h5 class="mt-3">Risiko</h5>
                    <hr class="mt-0" />
                  </div>
                </div>
                <div class="row">
                  <div class="col" style="max-width: 700px">
                    <label class="text-muted d-block mb-1"><small>Beschreibung</small></label>
                    <b-form-textarea
                      id="textarea"
                      placeholder="Langtext..."
                      rows="3"
                      max-rows="3"
                      v-model="record.RiskDescription"
                      @keyup="onFormFieldKeyUp"
                      :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                    ></b-form-textarea>
                  </div>
                  <div class="col align-self-end" style="max-width: 300px">
                    <label class="text-muted d-block mt-1 mb-1"><small>Kostenrisiko</small></label>
                    <!--
                    <b-input-group append="€">
                      <b-input
                        class="text-right"
                        placeholder="Betrag"
                        v-model="record.RiskAmount"
                        type="number"
                        @keyup="onFormFieldKeyUp"
                        :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                      />
                    </b-input-group>-->
                    <AkCurrencyField
                      input-class="text-right"
                      placeholder="Betrag"
                      v-model="record.RiskAmount"
                      type="number"
                      @keyup="onFormFieldKeyUp"
                      :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col" style="max-width: 1000px">
                    <h5 class="mt-3">Terminauswirkungen</h5>
                    <hr class="mt-0" />
                  </div>
                </div>
                <div class="row">
                  <div class="col" style="max-width: 700px">
                    <label class="text-muted d-block mb-1"><small>Beschreibung</small></label>
                    <b-form-textarea
                      id="textarea"
                      placeholder="Langtext..."
                      rows="3"
                      max-rows="3"
                      v-model="record.ScheduleDescription"
                      @keyup="onFormFieldKeyUp"
                      :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                    ></b-form-textarea>
                  </div>
                  <div class="col align-self-end" style="max-width: 300px">
                    <label class="text-muted d-block mb-1"><small>Terminrisiko</small></label>
                    <b-input
                      placeholder="Optionale Angabe..."
                      v-model="record.ScheduleRisk"
                      @keyup="onFormFieldKeyUp"
                      :readonly="record.DecisionText && record.DecisionText != 'Offen'"
                    />
                  </div>
                </div>
              </b-form>
            </b-overlay>
          </b-tab>
          <!----------------------------
            TAB: PÄT-Entscheidung
          ------------------------------>
          <b-tab
            title="PÄT-Entscheidung"
            :disabled="record ? !record.DbId : true"
            class="p-4"
            @click="fillFieldsIfEmpty"
          >
            <!----------------------------
              Infozeile mit drei Feldern
            ------------------------------>
            <div class="row mb-4">
              <div class="col" style="max-width: 1000px">
                <div class="row">
                  <div class="col">
                    <label class="text-muted d-block mb-1"><small>Budgetbedarf PÄT</small></label>
                    <div class="bg-light p-1">
                      {{ formatCurrency(record.BudgetDemand) }}
                    </div>
                  </div>
                  <div class="col">
                    <label class="text-muted d-block mb-1"><small>Kostenrisiko</small></label>
                    <div class="bg-light p-1">
                      {{ formatCurrency(record.RiskAmount) }}
                    </div>
                  </div>
                  <div class="col">
                    <label class="text-muted d-block mb-1"><small>Terminrisiko</small></label>
                    <div class="bg-light p-1">
                      {{ record.ScheduleRisk ? record.ScheduleRisk : '&nbsp;' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!----------------------------
              Entscheidungsformular
            ------------------------------>
            <div class="row">
              <div class="col" style="max-width: 1000px">
                <h5 class="">PÄT Entscheidung</h5>
                <hr class="mt-0" />
              </div>
            </div>
            <div class="row">
              <div class="col" style="max-width: 1000px">
                <div class="card">
                  <b-form ref="decisionForm" id="patDecisionForm">
                    <div class="card-body pt-2 bg-primary-light">
                      <div class="row mb-1">
                        <div class="col col-6 pr-0">
                          <label class="text-muted d-block mb-1"><small>Datum</small></label>
                          <b-input
                            v-model="decision.Date"
                            required
                            @change="decisionFormChanged = true"
                            type="date"
                            min="2000-01-01"
                            max="2099-12-31"
                            :disabled="!$root.$user.isPlaner && !$root.$user.isAdmin"
                          />
                          <label class="text-muted d-block mb-1"><small>Freigabebudget</small></label>
                          <!--
                          <b-input-group append="€">
                            <b-input
                              v-model="decision.DecisionBudget"
                              type="number"
                              @change="decisionFormChanged = true"
                            />                            
                          </b-input-group>
                          -->
                          <AkCurrencyField
                            v-model="decision.DecisionBudget"
                            type="number"
                            @update="decisionFormChanged = true"
                            append
                            :disabled="!$root.$user.isPlaner && !$root.$user.isAdmin"
                          />
                          <label class="text-muted d-block mb-1"><small>Entscheidung</small></label>
                          <b-form-select
                            ref="decisionSelect"
                            :options="decisionOptions"
                            v-model="decision.DecisionText"
                            @change="onDecisionSelectChange"
                            required
                            :disabled="!$root.$user.isPlaner && !$root.$user.isAdmin"
                          />
                        </div>
                        <div class="col col-6">
                          <label class="text-muted d-block mb-1"><small>Kommentar</small></label>
                          <!--- <b-input v-model="decision.DecisionComment" @input="decisionFormChanged = true" /> --->
                          <b-form-textarea
                            style="height: 158px"
                            id="textarea1"
                            v-model="decision.DecisionComment"
                            placeholder="Kommentar..."
                            rows="5"
                            max-rows="5"
                            @input="decisionFormChanged = true"
                            maxlength="400"
                            :disabled="!$root.$user.isPlaner && !$root.$user.isAdmin"
                          ></b-form-textarea>
                        </div>
                      </div>
                      <!--
                      <div class="row mb-1">
                        <div class="col col-2 align-self-end pr-0">
                          <label class="text-muted d-block mb-1"><small>Datum</small></label>
                          <b-input v-model="decision.Date" required @change="decisionFormChanged = true" />
                        </div>
                        <div class="col col-2 align-self-end pr-0">
                          <label class="text-muted d-block mb-1"><small>Freigabebudget</small></label>
                          <b-input-group append="€">
                            <b-input
                              v-model="decision.DecisionBudget"
                              type="number"
                              @change="decisionFormChanged = true"
                            />
                          </b-input-group>
                        </div>
                        <div class="col col-2 align-self-end pr-0">
                          <label class="text-muted d-block mb-1"><small>Entscheidung</small></label>
                          <b-form-select
                            ref="decisionSelect"
                            :options="decisionOptions"
                            v-model="decision.DecisionText"
                            @change="decisionFormChanged = true"
                            required
                          />
                        </div>
                        <div class="col col-6 align-self-end">
                          <label class="text-muted d-block mb-1"><small>Kommentar</small></label>
                          <b-input v-model="decision.DecisionComment" @input="decisionFormChanged = true" />
                        </div>
                      </div> -->
                      <!--- <div class="row mt-3" v-if="!decision.taken"> --->
                      <div class="row mt-3">
                        <div class="col">
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="saveDecision"
                            :disabled="!decisionFormChanged"
                            v-if="$root.$user.isPlaner || $root.$user.isAdmin"
                          >
                            Entscheidung speichern
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </b-form>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col" style="max-width: 1000px">
                <h5 class="mt-4">Entscheidungshistorie</h5>
                <hr class="mt-0" />
              </div>
            </div>
            <div class="row">
              <div class="col" style="max-width: 1000px">
                <b-table
                  borderless
                  class="ml-2"
                  :items="decisionHistory"
                  :fields="decisionHistoryFields"
                  :busy="decisionHistoryTableIsBusy"
                >
                  <template #cell(DecisionText)="data">
                    <b-badge
                      :variant="evaluateBadgeVariant(data.item)"
                      class="font-weight-normal p-1 m-0 d-inline align-middle"
                    >
                      {{ data.item.DecisionText }}
                    </b-badge>
                  </template>
                  <template #cell(DecisionBudget)="data">
                    {{ formatCurrency(data.item.DecisionBudget) }}
                  </template>
                  <template #cell(DecisionDate)="data">
                    {{ $utils.SQLDateToGermanDate(data.item.DecisionDate) }}
                  </template>
                </b-table>
              </div>
            </div>
          </b-tab>
          <!----------------------------
            TAB: Budgetzuordnung
          ------------------------------>
          <b-tab
            title="Budgetzuordnung"
            class="p-4"
            :disabled="record && record.DecisionText == 'Freigegeben' ? false : true"
            @click="refreshAllocationData"
          >
            <div class="row mb-4">
              <div class="col" style="max-width: 1000px">
                <div class="row">
                  <div class="col">
                    <label class="text-muted d-block mb-1"><small>Freigegebenes Budget</small></label>
                    <div class="bg-light p-1">
                      {{ formatCurrency(record.Budget) }}
                    </div>
                  </div>
                  <div class="col">
                    <label class="text-muted d-block mb-1"><small>Zugewiesen</small></label>
                    <div class="bg-light p-1">
                      {{ formatCurrency(this.patAllocatedBudget) }}
                    </div>
                  </div>
                  <div class="col">
                    <label class="text-muted d-block mb-1"><small>Restbudget</small></label>
                    <div class="bg-light p-1">
                      {{ formatCurrency(parseFloat(record.Budget) - parseFloat(this.patAllocatedBudget)) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col" style="max-width: 1000px">
                <b-form ref="newRecordForm" id="newRecordFormKKEBudgets">
                  <b-table
                    :items="allocations"
                    fixed
                    small
                    bordered
                    class="bg-white budgetSourcesTable sum-header"
                    :fields="allocationsFields"
                    head-variant="light"
                    show-empty
                    :busy="tableIsBusy"
                    sticky-header="613px"
                  >
                    <template #empty>
                      <div class="block text-center text-muted p-5">Keine Budgetierungen vorhanden.</div>
                    </template>
                    <template #head(Amount)="data">
                      <div style="padding-right: 11px">
                        {{ data.label }}
                      </div>
                      <div class="font-weight-bold text-grey">
                        {{ formatCurrency(patAllocatedBudget) }}
                      </div>
                    </template>

                    <template #cell(Target)>VE</template>
                    <template #head(Ratio)="data">{{ data.label }}</template>
                    <!---------------------------------
                    EDIT FIELD  R A T I O
                ---------------------------------->
                    <template #cell(Ratio)="data">
                      <div
                        class=""
                        style="padding-right: 9px"
                        v-if="!data.item.editMode"
                        @click="editAllocation(data.item, 'ratioField')"
                      >
                        {{ $utils.numberWithMaxFrictionsDE((data.item.Amount / record.Budget) * 100, 1) }} %
                      </div>
                      <b-input-group append="%" v-if="data.item.editMode">
                        <input
                          :required="data.item.editMode"
                          v-model.lazy="data.item.Ratio"
                          class="form-control table-input-field px-2 text-right"
                          :ref="'ratioField-' + data.item.Id"
                          :name="'ratioField-' + data.item.Id"
                          :id="'ratioField-' + data.item.Id"
                          @keyup.esc="cancelRowEdit(data.item)"
                          @keyup.enter="updateAllocationItem(data.item)"
                          placeholder="Anteil"
                          type="number"
                          @change="onEditRowRatioChanged(data.item)"
                        />
                      </b-input-group>
                    </template>
                    <!---------------------------------
                    EDIT FIELD A M O U N T
                ---------------------------------->
                    <template #cell(Amount)="data">
                      <div
                        class=""
                        style="padding-right: 9px"
                        v-show="!data.item.editMode"
                        @click="editAllocation(data.item, 'budgetAmountField')"
                      >
                        {{ formatCurrency(data.item.Amount) }}
                      </div>
                      <b-input-group append="€" v-if="data.item.editMode">
                        <input
                          :required="data.item.editMode"
                          v-model.lazy="data.item.Amount"
                          class="form-control table-input-field px-2 text-right"
                          :ref="'budgetAmountField-' + data.item.Id"
                          :name="'budgetAmountField-' + data.item.Id"
                          :id="'budgetAmountField-' + data.item.Id"
                          @keyup.esc="cancelRowEdit(data.item)"
                          @keyup.enter="updateAllocationItem(data.item)"
                          placeholder="Betrag"
                          type="number"
                          step="0.01"
                          pattern="^\d+(?:\.\d{1,2})?$"
                          @change="onEditRowValueChanged(data.item)"
                          @keydown.tab.prevent.stop="$refs['ratioField-' + data.item.Id].focus()"
                        />
                      </b-input-group>
                    </template>
                    <template #cell(actions)="data">
                      <!--- E D I T  
                      <b-icon
                        v-if="!data.item.editMode"
                        icon="pencil"
                        variant="grey"
                        class="action-button mr-2"
                        @click="editAllocation(data.item)"
                      ></b-icon>--->
                      <!--- D E L E T E  --->
                      <b-icon
                        v-if="!data.item.editMode && ($root.$user.isPlaner || $root.$user.isAdmin)"
                        icon="trash"
                        variant="grey"
                        class="action-button mr-2"
                        @click="deleteAllocation(data.item)"
                      ></b-icon>
                      <!--- C O M M E N T  --->
                      <b-icon
                        v-if="!data.item.editMode"
                        icon="info-circle"
                        variant="grey"
                        class="action-button"
                        @click="editComment(data.item)"
                      ></b-icon>
                      <!--- A C C E P T   ACTION: ONLY VISIBLE, IF ENTRY IS IN EDIT MODE --->
                      <b-icon
                        v-show="data.item.editMode"
                        title="Bearbeiten"
                        icon="check2"
                        variant="grey"
                        class="action-button mr-2"
                        @click="updateAllocationItem(data.item)"
                      ></b-icon>
                      <!--- C A N C E L   ACTION: ONLY VISIBLE, IF ENTRY IS IN EDIT MODE --->
                      <b-icon
                        v-show="data.item.editMode"
                        title="Bearbeiten abbrechen"
                        icon="x"
                        variant="grey"
                        class="action-button"
                        @click="cancelRowEdit(data.item)"
                      ></b-icon>
                    </template>
                    <template #custom-foot="">
                      <!---------------------------------
                    NEW RECORD ROW
                ---------------------------------->
                      <b-tr
                        style="border-top: 2px solid #dee2e6; border-bottom: 2px solid #dee2e6"
                        v-if="$root.$user.isPlaner || $root.$user.isAdmin"
                      >
                        <b-td class="align-middle table-edit-field">VE</b-td>
                        <b-td class="p-0 align-middle table-edit-field" colspan="2">
                          <!--- FIELD   Q U E L L E --->
                          <b-form-select
                            required
                            v-model="newBudgetAllocationRecord.VeId"
                            :options="sourcesWithBudget"
                            text-field="DisplayText"
                            value-field="DbId"
                            class="mr-2 border-0 shadow-none table-edit-field"
                            id="input-select-1"
                            placeholder="Kostenkontrolleinheit"
                            ref="newRecordSourceField"
                            @change="
                              onSourceChanged();
                              alertShow = false;
                            "
                          ></b-form-select>
                        </b-td>
                        <b-td class="p-0 align-middle table-edit-field">
                          <!--- FIELD P R O Z E N T --->
                          <b-input-group append="%">
                            <b-input
                              v-model="newBudgetAllocationPercentage"
                              placeholder="Anteil"
                              type="number"
                              ref="allocationRatioField"
                              step=".1"
                              class="text-right border-0 shadow-none table-edit-field"
                              @keydown.enter.prevent.stop="createPatAllocation"
                              @keyup.esc="newBudgetAllocationPercentage = null"
                              @change="onNewRecordRowPercentValueChanged"
                              @focus="alertShow = false"
                            />
                          </b-input-group>
                        </b-td>
                        <b-td class="p-0 align-middle table-edit-field">
                          <!--- FIELD B E T R A G --->
                          <b-input-group append="€">
                            <b-input
                              v-model="newBudgetAllocationAmount"
                              placeholder="Betrag"
                              required
                              type="number"
                              step="0.01"
                              pattern="^\d+(?:\.\d{1,2})?$"
                              ref="allocationAmountField"
                              class="text-right border-0 shadow-none table-edit-field"
                              @keydown="clearCustomValidity"
                              @keydown.enter.prevent.stop="createPatAllocation"
                              @keyup.esc="newBudgetAllocationAmount = null"
                              @change="onNewRecordRowAmountValueChanged"
                              @keydown.tab.prevent.stop="$refs['newRecordSourceField'].focus()"
                              @focus="alertShow = false"
                            />
                          </b-input-group>
                        </b-td>
                        <b-td class="py-0 align-middle table-edit-field text-center">
                          <!--- A C C E P T   --->
                          <b-icon
                            icon="check2"
                            variant="grey"
                            @click="createPatAllocation"
                            title="Neue Zuordnung speichern"
                            class="action-button"
                          />
                          <b-icon
                            icon="x"
                            variant="grey"
                            @click="clearNewRecordFields"
                            title="Neue Zuordnung abbrechen"
                            class="action-button"
                          />
                        </b-td>
                      </b-tr>
                    </template>
                  </b-table>
                </b-form>
                <b-alert fade variant="danger" :show="alertShow" dismissible @dismissed="alertShow = false">
                  <b-icon icon="exclamation-triangle" class="mr-3" style="margin-left: 4px" scale="1.5"></b-icon>
                  <span v-html="alertText" :class="{ 'font-weight-bold': alertBody }" />
                  <div v-html="alertBody" />
                </b-alert>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <!------------------------
          MODAL DIALOGS
    -------------------------->
    </div>
    <EditCommentDialog
      :allocation="currentAllocation"
      :source="record"
      sourceDesc="Quelle (PÄT)"
      modalId="EditPatCommentModal"
    />
  </div>
</template>
<script>
import settingsStore from '@/store/Settings';
import PatsService from '@/service/PatsService';
import CostGroupsService from '@/service/CostGroupsService';
import AppState from '@/store/App.js';
import EditCommentDialog from '@/components/budget/CommentDialog';
import AkCurrencyField from '../components/AkCurrencyField.vue';

export default {
  components: { EditCommentDialog, AkCurrencyField },
  mounted() {},
  activated() {
    this.clearRecord();
    AppState.isLoading = false;
    if (this.$router.currentRoute.params && this.$router.currentRoute.params.id) {
      // Load existing record into form
      this.isLoading = true;
      this.decisionHistoryTableIsBusy = true;
      PatsService.getDecisionHistory(this.$router.currentRoute.params.id)
        .then(records => (this.decisionHistory = records))
        .catch(err => this.$showError(this, err.toString()))
        .finally(() => (this.decisionHistoryTableIsBusy = false));
      PatsService.getById(this.$router.currentRoute.params.id)
        .then(record => {
          record.DateFormatted = this.$utils.SQLDateToBrowserDate(record.Date);
          this.decision.DecisionComment = record.DecisionComment;
          this.decision.DecisionText = record.DecisionText;
          this.decision.DecisionBudget = record.DecisionBudget;
          this.decisionBackup = { ...this.decision };
          this.currentOrdinal = record.Ordinal;
          this.currentDisplayName = record.DisplayName;
          this.record = record;

          const patFields = settingsStore.settings['PAT_Fields'];
          const patFieldCount = patFields.length; // 5
          const budgetPartsCount = this.record.BudgetParts.length; // 4

          for (let i = 0; i < budgetPartsCount; i++) {
            this.record.BudgetParts[i].default = patFields[i];
          }

          for (let i = budgetPartsCount; i < patFieldCount; i++) {
            this.record.BudgetParts[i] = {
              description: patFields[i],
              default: patFields[i],
              value: 0
            };
          }

          this.recalcBudgetSum();
          if (this.$router.currentRoute.query && this.$router.currentRoute.query.t) {
            switch (parseInt(this.$router.currentRoute.query.t)) {
              case 1:
                //this.recalcBudgetSum();
                this.fillFieldsIfEmpty();
                break;
              case 2:
                this.fillFieldsIfEmpty();
                this.refreshAllocationData();
                break;
            }
            this.$nextTick(() => {
              this.activeTab = parseInt(this.$router.currentRoute.query.t);
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$showError(this, err.toString());
        })
        .finally(() => {
          this.isLoading = false;
          this.recordFormChanged = false;
          this.decisionFormChanged = false;
          this.allocationsChanged = false;
        });
    } else {
      // new record, copy pat fields with value=0 into budetparts
      this.record.BudgetParts = [];
      const patFields = settingsStore.settings['PAT_Fields'];
      console.log('zzz patfields', patFields);
      const patFieldCount = patFields.length; // 5
      for (let i = 0; i < patFieldCount; i++) {
        this.record.BudgetParts.push({
          description: patFields[i],
          default: patFields[i],
          value: 0.0
        });
      }
      this.recalcBudgetSum();
      this.$refs.patNumberField.focus();
    }
    this.onWindowResize();
    //
  },
  data() {
    return {
      currentOrdinal: null,
      currentDisplayName: null,
      currentAllocation: {
        RefDbId: null
      },
      record: {
        DbId: null,
        Ordinal: null,
        DisplayName: null,
        Date: null,
        DateFormatted: null,
        Description: null,
        BudgetParts: [],
        BudgetDemand: null,
        Budget: null,
        RiskDescription: null,
        RiskAmount: null,
        ScheduleDescription: null,
        ScheduleRisk: null
      },
      decision: {
        Date: null,
        BudgetApproved: null,
        DecisionComment: null,
        DecisionText: null
      },
      decisionBackup: null,
      settingsStore,
      isLoading: false,
      decisionOptions: ['Offen', 'Abgelehnt', 'Freigegeben'],
      posAmount: [],
      posDescription: [],
      posTotalAmount: null,
      activeTab: 0,
      decisionHistoryFields: [
        { key: 'Ordinal', label: 'PÄT-Nr.', thClass: 'text-muted', tdClass: 'border-top' },
        { key: 'DecisionDate', label: 'Datum', thClass: 'text-muted', tdClass: 'border-top' },
        { key: 'DecisionText', label: 'Entscheidung', thClass: 'text-muted', tdClass: 'border-top align-top' },
        { key: 'DecisionBudget', label: 'Freigegebenes PÄT Budget', thClass: 'text-muted', tdClass: 'border-top' },
        { key: 'DecisionComment', label: 'Bemerkung', thClass: 'text-muted', tdClass: 'border-top' }
      ],
      decisionHistory: [],
      tabHeight: '900px',
      allocations: [],
      allocationsFields: [
        {
          key: 'Target',
          label: 'Ziel',
          thClass: 'align-top noselect',
          thStyle: 'width:100px',
          tdClass: 'align-middle'
        },
        {
          key: 'Ordinal',
          label: 'Nr',
          thClass: 'align-top noselect',
          tdClass: 'align-middle',
          thStyle: 'width:150px',
          sortable: true
        },
        {
          key: 'DisplayName',
          label: 'Bezeichnung',
          thClass: 'align-top noselect',
          tdClass: 'align-middle',
          sortable: true
        },
        {
          key: 'Ratio',
          label: 'Anteil',
          thClass: 'align-top noselect',
          thStyle: 'width:200px',
          tdClass: 'align-middle text-right p-0 action-button',
          sortable: true
        },
        {
          key: 'Amount',
          label: 'Zugewiesen',
          thClass: 'align-top text-right noselect',
          thStyle: 'width:250px;padding-right: 5px;',
          tdClass: 'text-right align-middle p-0 action-button',
          formatter: x => this.$utils.numberToCurrency(x, settingsStore.settings['Centbetraege']),
          sortable: true
        },
        {
          key: 'Actions',
          label: 'Aktionen',
          thClass: 'align-top noselect',
          tdClass: 'text-center align-middle',
          thStyle: 'width: 100px'
        }
      ],
      tableIsBusy: false,
      decisionHistoryTableIsBusy: false,
      patAllocatedBudget: 0,
      sourcesWithBudget: [],
      newBudgetAllocationRecord: {},
      newBudgetAllocationPercentage: null,
      newBudgetAllocationAmount: null,
      allocationId: 0,
      alertText: null,
      alertBody: null,
      alertShow: false,
      recordFormChanged: false,
      decisionFormChanged: false,
      allocationsChanged: false
    };
  },
  methods: {
    printIt() {
      //window.open('' + this.$route.params.id + '/print?nav=false', 'printWindow', 'location=no,height=700,width=1000');
      window.open(this.$route.params.id + '/print?nav=false', '_blank');
    },
    onFormFieldKeyUp(key) {
      if (
        key.which == 9 ||
        key.which == 13 ||
        key.which == 16 ||
        key.which == 27 ||
        key.which == 32 ||
        key.which == 35 ||
        key.which == 36 ||
        key.which == 37 ||
        key.which == 39
      )
        return;
      if (!this.record.DecisionText || (this.record.DecisionText && this.record.DecisionText == 'Offen'))
        this.recordFormChanged = true;
    },
    editComment(item) {
      this.currentAllocation = { ...item };
      this.$nextTick(() => {
        this.$bvModal.show('EditPatCommentModal');
      });
    },
    loadAllocations() {
      this.tableIsBusy = true;
      PatsService.getAllocations(this.$route.params.id)
        .then(results => {
          this.allocations = results.map(x => {
            x.Source = 'pat';
            x.Id = x.Source + x.DbId;
            x.RefDbId = x.DbId;
            x.editMode = false;
            x.Amount = parseFloat(x.Amount);
            x.Ratio = parseFloat((x.Amount / x.Budget) * 100).toFixed(1);
            return x;
          });
          this.recalcBudgetAllocatedSum();
        })
        .catch(err => this.$showError(this, err.toString()))
        .finally(() => {
          this.tableIsBusy = false;
          this.allocationsChanged = false;
        });
    },
    loadAllocationUnitsWithBudget() {
      CostGroupsService.getBudgetSourcesWithBudget('ve')
        .then(results => {
          this.sourcesWithBudget = results.map(x => {
            x.DisplayText =
              x.Ordinal +
              ' ' +
              x.DisplayName +
              ' (' +
              this.$utils.numberToCurrency(x.BudgetSaldo, settingsStore.settings['Centbetraege']) +
              ')';
            return x;
          });
        })
        .catch(err => this.$showError(this, err.toString()));
    },
    editAllocation() {
      this.alertShow = false;
    },
    refreshAllocationData() {
      this.loadAllocations();
      this.loadAllocationUnitsWithBudget();
      this.clearNewRecordFields();
    },
    saveRecordAndReturn(evt) {
      if (!this.$refs.recordForm.checkValidity()) {
        evt.preventDefault();
        return this.$refs.recordForm.reportValidity();
      }
      this.isLoading = true;

      this.record.Date = this.record.DateFormatted;

      this.record.BudgetDemand = this.posTotalAmount;

      if (this.record.DbId) {
        PatsService.update(this.record)
          .then(() => {
            this.currentOrdinal = this.record.Ordinal;
            this.currentDisplayName = this.record.DisplayName;
            this.$nextTick(() => {
              this.$showSuccess(this, 'PÄT bearbeiten', 'PÄT erfolgreich gespeichert.');
            });
          })
          .catch(err => {
            console.trace(err);
            this.$showError(this, err.toString());
          })
          .finally(() => {
            this.isLoading = false;
            this.recordFormChanged = false;
            this.decisionFormChanged = false;
            this.allocationsChanged = false;
          });
      } else {
        PatsService.create(this.record)
          .then(result => {
            this.record.DbId = result.insertId;
            this.currentOrdinal = this.record.Ordinal;
            this.currentDisplayName = this.record.DisplayName;

            this.fillFieldsIfEmpty();
            this.$nextTick(() => {
              this.activeTab = 1;
              this.$nextTick(() => {
                this.$showSuccess(this, 'PÄT erstellen', 'PÄT erfolgreich gespeichert.');
              });
            });
          })
          .catch(err => {
            if (err.response) this.$showError(this, err.response.data.error);
            else this.$showError(this, err.toString());
          })
          .finally(() => {
            this.isLoading = false;
            this.recordFormChanged = false;
            this.decisionFormChanged = false;
            this.allocationsChanged = false;
          });
      }
    },
    saveDecision() {
      //console.log("zzz Budget, BudgetApproved" , this.decision.Budget, this.decision.BudgetApproved)
      this.decision.Budget = this.decision.BudgetApproved;
      if (this.decision.DecisionText == 'Freigegeben') {
        this.record.Budget = this.decision.DecisionBudget;
        this.decision.Budget = this.decision.DecisionBudget;
      } else if (this.decision.DecisionText == 'Abgelehnt') {
        this.record.Budget = 0;
        this.decision.Budget = 0;
        this.decision.DecisionBudget = 0;
      } else {
        this.record.Budget = 0;
        this.decision.Budget = 0;
      }
      const decisionToPost = { ...this.decision };
      decisionToPost.PatId = this.record.DbId;
      decisionToPost.Date = this.$utils.browserDateToSQLDate(decisionToPost.Date);

      PatsService.saveDecision(decisionToPost)
        .then(() => {
          this.decisionBackup = { ...this.decision };
          this.decisionHistoryTableIsBusy = true;
          this.record.DecisionText = this.decision.DecisionText;
          PatsService.getDecisionHistory(this.$router.currentRoute.params.id)
            .then(records => (this.decisionHistory = records))
            .catch(err => {
              if (err.response) this.$showError(this, err.response.data.error.text);
              else this.$showError(this, err.toString());
            })
            .finally(() => (this.decisionHistoryTableIsBusy = false));
          this.$showSuccess(this, 'PÄT Entscheidung', 'Entscheidung erfolgreich gespeichert.');
          this.decisionFormChanged = false;
        })
        .catch(err => {
          this.decision = { ...this.decisionBackup };
          this.record.Budget = this.decision.DecisionBudget;
          if (err.response && err.response.status == 510) {
            this.decision.Date = this.$utils.currentBrowserDate();
            this.$bvModal.msgBoxOk(
              'Das Budget dieses Änderungstestats wurde bereits zugeordnet. Bitte löschen Sie diese Zuordnung, bevor die Entscheidung geändert werden kann.',
              {
                title: 'Änderungstestat - Entscheidung ändern',
                okVariant: 'danger',
                headerTextVariant: 'danger',
                centered: true
              }
            );
          } else if (err.response) this.$showError(this, err.response.data);
          else this.$showError(this, err.toString());
        })
        .finally(() => {});
    },
    showAlert(textToShow, messageBody = '') {
      this.alertText = textToShow;
      this.alertBody = messageBody;
      this.alertShow = true;
    },
    saveAllocations() {
      /*if (this.allocations.length == 0) {
        return this.showAlert('Es wurden keine Zuordnungen eingebenen.');
      }*/
      if (this.record.Budget == 0 && this.patAllocatedBudget != 0) {
        return this.showAlert(
          'Die Summe der Zuordnungen (' +
            this.formatCurrency(this.patAllocatedBudget) +
            ') muss bei einem Freigabebuget von 0 € genau 0 € betragen.'
        );
      }
      if (this.record.Budget > 0 && this.patAllocatedBudget > this.record.Budget) {
        return this.showAlert(
          'Die Summe der Zuordnungen (' +
            this.formatCurrency(this.patAllocatedBudget) +
            ') darf das freigegebene Budget (' +
            this.formatCurrency(this.record.Budget) +
            ') nicht überschreiten'
        );
      }
      if (this.record.Budget > 0 && this.patAllocatedBudget < 0) {
        return this.showAlert('Die Summe der Zuordnungen darf nicht negativ sein.');
      }
      if (this.record.Budget < 0 && this.patAllocatedBudget < this.record.Budget) {
        return this.showAlert(
          'Die Summe der Zuordnungen (' +
            this.formatCurrency(this.patAllocatedBudget) +
            ') darf das freigegebene Budget (' +
            this.formatCurrency(this.record.Budget) +
            ') nicht unterschreiten'
        );
      }
      if (this.record.Budget < 0 && this.patAllocatedBudget > 0) {
        return this.showAlert('Die Summe der Zuordnungen darf nicht positiv sein.');
      }
      this.tableIsBusy = true;
      PatsService.updateAllocations(this.$router.currentRoute.params.id, this.allocations)
        .then(() => {
          this.refreshAllocationData();
          this.alertShow = false;
          this.$showSuccess(this, 'Zuordnungen speichern', 'Zuordnungen erfolgreich gespeichert.');
        })
        .catch(err => {
          if (err.response) {
            //const h = this.$createElement;
            const header = `Die Zuordnungen konnten aufgrund einer Budgetüberprüfung nicht gespeichert werden.`;

            var message =
              '<br>Folgende Budgetverletzungen sind aufgetreten:<br><br><table class="table table-bordered table-sm bg-white"><thead><tr><th>VE</th><th>VE-Budget nach Veränderung</th><th>Grund</th></tr></thead>';
            for (const faultyItem of err.response.data) {
              message +=
                '<tr><td>' +
                faultyItem.Ordinal +
                ' ' +
                faultyItem.DisplayName +
                //'</td><td class="text-right">' +
                //this.formatCurrency(faultyItem.BudgetChange).toString() +
                '</td><td class="text-right">' +
                this.formatCurrency(faultyItem.BudgetSaldo).toString() +
                '</td><td>' +
                faultyItem.FailureReason +
                '</td></tr>';
            }
            message += '</table>';
            message +=
              'Bitte prüfen Sie die Vergabeeinheiten auf ausreichend Budget und speichern Sie die Zuordnungen erneut.';
            /*const messageVNode = h('div', { domProps: { innerHTML: message } });
            this.$bvModal.msgBoxOk([messageVNode], {
              title: 'Zuordnungen speichern',
              okTitle: 'OK',
              cancelTitle: 'Abbrechen',
              okVariant: 'danger',
              centered: true
            });*/
            /*
            this.alertBody = message;
            this.alertShow = true;
            this.alertText = header;*/
            this.showAlert(header, message);
            //this.loadAllocations();
          } else this.$showError(this, err.toString());
        })
        .finally(() => {
          this.tableIsBusy = false;
        });
    },
    updateRecord() {},
    fillFieldsIfEmpty() {
      this.decision = { ...this.decisionBackup };

      if (!this.decision.Date || this.decision.Date == '') this.decision.Date = this.$utils.currentBrowserDate();
      if (!this.decision.DecisionText) this.decision.DecisionText = 'Offen';
      if (this.decision.DecisionText == 'Offen') this.decision.DecisionBudget = this.posTotalAmount;
      this.decisionFormChanged = false;
    },
    recalcBudgetSum() {
      var sum = 0;
      var amountToAdd = 0;
      for (var amount of this.record.BudgetParts) {
        if (!amount.value || amount.value == '') amountToAdd = 0;
        else amountToAdd = amount.value;

        sum += parseFloat(amountToAdd);
      }
      this.posTotalAmount = sum;
    },

    onWindowResize() {
      const totalHeight = window.innerHeight;
      this.tabHeight = totalHeight - 125 + 'px';
    },
    evaluateBadgeVariant(item) {
      switch (item.DecisionText) {
        case 'Freigegeben':
          return 'success';
        case 'Abgelehnt':
          return 'danger';
        case 'Offen':
          return 'light';
      }
    },
    recalcBudgetAllocatedSum() {
      this.patAllocatedBudget = 0;
      for (const allocation of this.allocations) {
        this.patAllocatedBudget += parseFloat(allocation.Amount);
      }
    },
    formatCurrency(number) {
      return this.$utils.numberToCurrency(number, settingsStore.settings['Centbetraege']);
    },
    clearCustomValidity() {},
    clearRecord() {
      this.record = {
        DbId: null,
        Ordinal: null,
        DisplayName: null,
        Date: null,
        DateFormatted: null,
        Description: null,
        BudgetParts: [],
        Budget: null,
        RiskDescription: null,
        RiskAmount: null,
        ScheduleDescription: null,
        ScheduleRisk: null
      };
      this.decision = {
        Date: null,
        BudgetApproved: null,
        DecisionComment: null,
        DecisionText: null,
        DecisionBudget: null
      };
      this.decisionBackup = {
        Date: null,
        BudgetApproved: null,
        DecisionComment: null,
        DecisionText: null,
        DecisionBudget: null
      };
      this.decisionHistory = [];
      this.allocations = [];
      this.posDescription = [];
      this.posAmount = [];
      this.posTotalAmount = null;
      this.alertShow = false;
      this.alertText = null;
    },
    clearNewRecordFields() {
      this.newBudgetAllocationRecord = {};
      this.newBudgetAllocationPercentage = null;
      this.newBudgetAllocationAmount = null;
    },
    onSourceChanged() {
      this.newBudgetAllocationPercentage = 100;
      this.newBudgetAllocationAmount = this.record.Budget - this.patAllocatedBudget;
    },
    onNewRecordRowPercentValueChanged() {
      this.newBudgetAllocationAmount =
        ((this.record.Budget - this.patAllocatedBudget) * this.newBudgetAllocationPercentage) / 100;
    },
    onNewRecordRowAmountValueChanged() {
      if (!this.newBudgetAllocationAmount) return;
      this.newBudgetAllocationPercentage = (
        (parseFloat(this.newBudgetAllocationAmount) / parseFloat(this.record.Budget)) *
        100
      ).toFixed(1);
    },
    createPatAllocation() {
      const source = this.sourcesWithBudget.find(x => x.DbId == this.newBudgetAllocationRecord.VeId);

      const input = this.$refs.allocationAmountField.$el;
      input.setCustomValidity('');

      if (this.newBudgetAllocationAmount == 0) {
        input.setCustomValidity('Betrag darf nicht 0 sein.');
        return input.reportValidity();
      }

      const newAllocation = {
        Amount: parseFloat(this.newBudgetAllocationAmount),
        DisplayName: source.DisplayName,
        DbId: this.allocationId--,
        Ordinal: source.Ordinal,
        PatId: this.record.DbId,
        Ratio: parseFloat(this.newBudgetAllocationPercentage),
        Source: 'pat',
        VeId: source.DbId,
        editMode: false
      };
      this.allocations.push(newAllocation);
      this.recalcBudgetAllocatedSum();
      this.clearNewRecordFields();
      this.allocationsChanged = true;
    },
    deleteAllocation(item) {
      this.$utils.deleteItemFromArray(this.allocations, x => x.DbId == item.DbId);
      /*
      if (item.DbId > 0) {
        PatsService.deleteAllocation(item)
          .then(() => this.$showSuccess(this, 'Zuordnung löschen', 'Zuordnung erfolgreich gelöscht'))
          .catch(err => this.$showError(this, err.toString()));
      }*/
      this.recalcBudgetAllocatedSum();
      this.allocationsChanged = true;
      this.alertShow = false;
    },

    onTabChange(newTabIndex, prevTabIndex, evt) {
      if (prevTabIndex == 2 && newTabIndex != 2 && this.allocationsChanged) {
        const answer = window.confirm('Sie haben ungespeicherte Änderungen. Wollen Sie die Seite wirklich verlassen?');
        if (answer) {
          this.allocationsChanged = false;
        } else {
          evt.preventDefault();
        }
      } else if (prevTabIndex == 1 && newTabIndex != 1 && this.decisionFormChanged) {
        const answer = window.confirm('Sie haben ungespeicherte Änderungen. Wollen Sie die Seite wirklich verlassen?');
        if (answer) {
          this.allocationsChanged = false;
        } else {
          evt.preventDefault();
        }
      }
    },
    onDecisionSelectChange(value) {
      this.decisionFormChanged = true;
      if (value == 'Offen') {
        this.decision.DecisionBudget = parseFloat(this.record.BudgetDemand);
      } else if (value == 'Abgelehnt') {
        this.decision.DecisionBudget = 0;
      } else if (value == 'Freigegeben' && this.decision.DecisionBudget == 0) {
        this.decision.DecisionBudget = parseFloat(this.record.BudgetDemand);
      }
    },
    takeOverDescription(index) {
      if (this.record.BudgetParts[index].description == '')
        this.record.BudgetParts[index].description = this.record.BudgetParts[index].default;
    }
  },

  deactivated() {},

  beforeRouteLeave(to, from, next) {
    if (this.recordFormChanged) {
      this.activeTab = 0;
      setTimeout(() => {
        const answer = window.confirm('Sie haben ungespeicherte Änderungen. Wollen Sie die Seite wirklich verlassen?');
        if (answer) {
          this.recordFormChanged = false;
          next();
        } else {
          next(false); // No, user wants to stay. Let's abort the navigation.
        }
      }, 100);
    } else if (this.decisionFormChanged) {
      this.activeTab = 1;
      setTimeout(() => {
        const answer = window.confirm('Sie haben ungespeicherte Änderungen. Wollen Sie die Seite wirklich verlassen?');
        if (answer) {
          // Yes, user wants to leave page without saving
          this.decisionFormChanged = false;
          next();
        } else {
          next(false); // No, user wants to stay. Let's abort the navigation.
        }
      }, 100);
    } else if (this.allocationsChanged) {
      this.activeTab = 2;
      setTimeout(() => {
        const answer = window.confirm('Sie haben ungespeicherte Änderungen. Wollen Sie die Seite wirklich verlassen?');
        if (answer) {
          // Yes, user wants to leave page without saving
          this.allocationsChanged = false;
          next();
        } else {
          next(false); // No, user wants to stay. Let's abort the navigation.
        }
      }, 100);
    } else next();
  }
};
</script>
<style scoped>
.bg-transparent {
  background-color: var(--bauvisor-light) !important;
}
.badge-success {
  color: var(--success);
  background-color: rgba(76, 151, 93, 0.15) !important;
}
.badge-danger {
  color: var(--danger);
  background-color: rgba(177, 78, 88, 0.15) !important;
}
input:read-only:focus {
  border-color: rgb(206, 212, 218);
}
</style>
